/*
 * @Author: your name
 * @Date: 2021-06-22 13:58:42
 * @LastEditTime: 2021-06-22 15:33:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-oms-facade\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store/index.js'
import ElementUI from 'element-ui'
import vueRouter from 'vue-router'
import axios from 'axios'
import Api from '@/api/index'
import echarts from 'echarts'
import 'babel-polyfill'
import '@/assets/icons'
import dataV from '@jiaminghi/data-view';
// 引入全局css
import './assets/screen/style.scss';

Vue.config.productionTip = false
Vue.use(dataV);
Vue.use(ElementUI)
Vue.use(vueRouter)
Vue.prototype.$ajax = axios
Vue.prototype.Api = Api
Vue.prototype.$echarts = echarts
import i18n from './lang' // Internationalization
import vueContextMenu from 'vue-contextmenu'

import '@/styles/theme/index.scss'

import App from './App'
import router from './routes'

import './directive/index.js'
import ecCmponents from './components/components.js'
import Excel from './components/report'
import ecUtils from './common/index.js'
import '@/permission'
import VueCron from 'vue-cron'
Vue.use(VueCron)
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak:"X7ywk5eB8IUeRmbIT8fEGUDUybn5FvqG"
})
Vue.use(ecCmponents)
Vue.use(ecUtils)
Vue.use(vueContextMenu)
Vue.use(Excel)

/* eslint-disable no-new */
const requireComponent = require.context(
  './components/reportForm/components/form/FormItem/',
  false,
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = fileName
    .split('/')
    .pop()
    .replace(/\.\w+$/, '')
  Vue.component(componentName, componentConfig.default || componentConfig)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js